
  import {Component, Vue, Watch} from "vue-property-decorator";
  import {RankingList, StatisticalData, deviceStatus} from "@/views/components";
  import deviceItem from "@/views/components/DeviceStatus/deviceItem";
  import YtoTable from "@/views/components/YtoTable/TtoTable.vue";
  import Scan from "@/views/components/Scan/Scan.vue";
  import config from "./config";
  import Form1 from "./Form1.vue";
  import Form2 from "./Form2.vue";
  import FormPic from "./FormPic.vue";
  import TableHeader from "./TableHeader.vue";
  import ScanforgetonShape1 from "@/views/scanforgeton/scanforgetonShape1.vue";
  import ScanforgetonShape2 from "@/views/scanforgeton/scanforgetonShape2.vue";
  import { ScanforGetOnModule } from "@/store/modules/store_scanforgeton";

  @Component({
    name: "scanforgeton",
    components: {
      ScanforgetonShape2,
      ScanforgetonShape1,
    }
  })
  export default class extends Vue {
    private useShape1 = false;
    private inputModel: inputDataModel = {
      checked_IsSumWeight: false,
      checked_IsOverTimeCar: false,
      checked_AutoCreateCarCode: false,
      checked_NeedWeight: false,
      input_CarLabel: "",
      checked_CarCodelocked: false,
      input_PacketCode: "",
      input_PanelLine: "",
      input_PanelLineName: "",
      input_NextorgSelect: "",
      input_NextWebPoint: "",
      input_CarNumInfo: "",
      input_RecvType: "",
      checked_RecvTypeLock: false,
      input_Weight: "",
      checked_IsCheckBagWeight: false,
      input_TempWeight: "",
      input_ScanCode: "",
      input_warehouseFlag:"",
      input_StartSoundPlay:false,
      warehouseFlagVisible:false,
      soundPlayDisable:true,
    };

    @Watch("inputModel", {deep: true})
    onChildChanged(val: string) {
      this.asyncSendDataToNet(val);
      this.callbackmodel = val;
    }

    @Watch("formModel2", {deep: true})
    onFormmodel2Changed(val: string) {
      // this.$emit("get-form2-value", val);
      this.getForm2Value(val);
    }

    //
    mounted() {
      //初始化设备状态
      this.deviceItems = [];
      for (let index = 1; index <= 12; index++) {
        this.deviceItems.push({
          name: "设备" + index.toString(),
          title: index.toString(),
          status: "defult"
        });
      }
      //初始化统计数据栏目内显示的数据
      this.statisticalList = [
        {label: "总扫描数", value: "0", combine: "1"},
        {label: "车内件数", value: "0", combine: "2"},
        {label: "车内累计重量", value: "0", combine: "3"}
      ];

      try {
        //注册设备状态回调函数
        if (typeof obj_ScanForGetOn !== 'undefined') {
          obj_ScanForGetOn.regist_getdevicestate(this.getdevicestatecallback);
          obj_ScanForGetOn.regist_datahistorycallback(this.datahistorycallback);
          obj_ScanForGetOn.regist_errormsgcallback(this.errormsgcallback);
          // obj_ScanForGetOn.regist_sendformdata(this.sendformdata);
          obj_ScanForGetOn.regist_statisticaldata(this.statisticaldatacallback);
          obj_ScanForGetOn.regist_updateformdata(this.scanareacallback);
          obj_ScanForGetOn.regist_ranklistupdate(this.ranklistupdatecallback);
          obj_ScanForGetOn.regist_errormsgshowcallback(this.errormsgshowcallback);
          obj_ScanForGetOn.regist_successmsgshowcallback(this.successmsgshowcallback);
        }
      } catch (error) {
        console.log("上车界面:注册回调函数异常" + error);
      }

      this.InitConfig();
      this.formModel2.checked_NeedWeight = true;

      var el = document.getElementById("input_scancode_id");
      this.selectElementContents(el);
      // this.$nextTick(() => {
      //   obj_ScanForGetOn.vueLoaded();
      // });
      try {
        setTimeout(() => {
          obj_ScanForGetOn.vueLoaded();
        }, 0.5 * 1000);
      } catch (error) {
        console.log("上车界面加载界面参数失败" + error);
      }
      try {
        this.routeNextOrgCode = obj_ScanForGetOn.getRouteNextOrgCode();
      } catch (error) {
        console.log("上车界面加载自动带下一网点开关出现错误:" + error);
      }
    }

    public routeNextOrgCode = "0";

    ///以下是原来form2的功能
    public AutoCreateCarCodeChangeFunc(isChecked) {
      if (isChecked) {
        if (this.inputModel.checked_CarCodelocked) {
          this.errormessage = "请先取消勾选车签锁定框";
          this.$nextTick(() => {
            this.formModel2.checked_AutoCreateCarCode = false;
            ScanforGetOnModule.AutoCreateCarCodeOldChangeState(false);
          });
          return;
        }
        if (
          this.inputModel.input_NextWebPoint === null ||
          this.inputModel.input_NextWebPoint === undefined ||
          this.inputModel.input_NextWebPoint === ""
        ) {

          if (this.routeNextOrgCode == "1") {
            //如果是黄埔仓模式，那么就不需要校验下一网点，可以勾选
            this.$nextTick(() => {
              this.formModel2.checked_AutoCreateCarCode = true;
              ScanforGetOnModule.AutoCreateCarCodeOldChangeState(true);
            });
          } else {
            //当勾选自动生成车签时，且下一网点为空
            this.errormessage = "该线路无法自动生成车签";
            // this.inputModel.input_CarLabel = "";
            this.$nextTick(() => {
              this.formModel2.checked_AutoCreateCarCode = false;
              ScanforGetOnModule.AutoCreateCarCodeOldChangeState(false);
            });
          }
        } else {
          //当勾选自动生成车签时，且下一网点不为空
          this.errormessage = "";
          var _nextwebpoint = this.inputModel.input_NextWebPoint;
          var orgs = this.nextOrgsOption;
          var orgtype = "";
          if (orgs !== null && orgs !== []) {
            orgs.forEach(element => {
              if (element.value === _nextwebpoint) {
                orgtype = element.orgtype;
              }
            });
          }

          if (orgtype === "转运中心") {
            this.errormessage = "该线路无法自动生成车签";
            // this.inputModel.input_CarLabel = "";
            this.$nextTick(() => {
              this.formModel2.checked_AutoCreateCarCode = false;
              ScanforGetOnModule.AutoCreateCarCodeOldChangeState(false);
            });
          } else {
            var carcode = obj_ScanForGetOn.getAutoCarCode(_nextwebpoint);
            this.inputModel.input_CarLabel = carcode;
          }
        }
      } else {
        //当取消勾选自动生成车签的勾选框时
        this.inputModel.input_CarLabel = "";
        this.errormessage = "";
      }
    }

    public ChooseNextWebPoint(nextWebPoint) {
      if (nextWebPoint == "") {
        return;
      }
      var _nextwebpoint = nextWebPoint;
      var orgs = this.nextOrgsOption;
      var orgtype = "";
      if (orgs !== null && orgs !== []) {
        orgs.forEach(element => {
          if (element.value === _nextwebpoint) {
            orgtype = element.orgtype;
          }
        });
      }
      if(ScanforGetOnModule.checked_AutoCreateCarCodeOld){
      // if (this.formModel2.checked_AutoCreateCarCode) {
        if (orgtype == "转运中心") {
          this.errormessage = "该线路无法自动生成车签";
          this.inputModel.input_CarLabel = "";
          this.formModel2.checked_AutoCreateCarCode = false;
          ScanforGetOnModule.AutoCreateCarCodeOldChangeState(false);
        } else {
          var carcode = obj_ScanForGetOn.getAutoCarCode(_nextwebpoint);
          this.inputModel.input_CarLabel = carcode;
        }
      } else {
        console.log("未勾选自动生成车签");
      }
    }

    private AutoCreateCarCodeShow: Boolean = true;

    private formModel2 = {
      checked_IsSumWeight: false,
      checked_IsOverTimeCar: false,
      checked_AutoCreateCarCode: false,
      checked_NeedWeight: false
    };

    private errormsgshowcallback(msg) {
      this.$message.error(msg)
    }

    private successmsgshowcallback(msg) {
      this.$message.success(msg)
    }

    public InitConfig() {
      if (typeof obj_ScanForGetOn !== 'undefined') {
        var _configData: configData = obj_ScanForGetOn.getScanForGetOnConfig();
        this.AutoCreateCarCodeShow = !_configData.isAutoCreateCarCodeShow;
        this.formModel2.checked_IsSumWeight = _configData.isSumWeightChecked;
      }
    }

    /// 排行榜数据
    public ranklistdata: rankListModel = {
      avgEfficiency: "0",
      lastHourAvgEfficiency: "0",
      avgEfficiencyRank: "0",
      frequencyRank: "0",
      wholeTopEfficiency: "0"
    };

    public nextOrgsOption = [];

    public storeNextOrgs(datas, NextOrgCode) {
      this.nextOrgsOption = datas;
    }

    //Form1界面回调
    public ranklistupdatecallback(dic) {
      this.ranklistdata = dic;
    }

    public asyncSendDataToNet(data) {
      return new Promise(() => {
        var result = obj_ScanForGetOn.sendformdataaction(data);
      });
    }

    //上传成功,为黑色，其他都是红色
    private rowClassAction(row) {
      if (/失败/.test(row.row.UploadStateName)) {
        return {color: "#f22613", "font-size": "130%", "font-weight": "bold"};
      }
      if (/重复/.test(row.row.UploadStateName)) {
        return {color: "#f22613", "font-size": "130%", "font-weight": "bold"};
      }
    }

    private getFormValue(element) {
      this.inputModel.input_NextWebPoint = element.input_NextWebPoint;
      this.inputModel.input_CarNumInfo = element.input_CarNumInfo;
      this.inputModel.input_RecvType = element.input_RecvType;
      this.inputModel.checked_RecvTypeLock = element.checked_RecvTypeLock;
      this.inputModel.input_Weight = element.input_Weight;
      this.inputModel.checked_IsCheckBagWeight = element.checked_IsCheckBagWeight;
      this.inputModel.input_TempWeight = element.input_TempWeight;
      this.inputModel.input_ScanCode = element.input_ScanCode;
      this.inputModel.input_CarLabel = element.input_CarLabel;
      this.inputModel.checked_CarCodelocked = element.checked_CarCodelocked;
      this.inputModel.input_PacketCode = element.input_PacketCode;
      this.inputModel.input_PanelLine = element.input_PanelLine;
      this.inputModel.input_PanelLineName = element.input_PanelLineName;
      this.inputModel.input_NextorgSelect = element.input_NextorgSelect;
    }

    private getForm2Value(element) {
      this.inputModel.checked_IsSumWeight = element.checked_IsSumWeight;
      this.inputModel.checked_IsOverTimeCar = element.checked_IsOverTimeCar;
      this.inputModel.checked_AutoCreateCarCode =
        element.checked_AutoCreateCarCode;
      ScanforGetOnModule.AutoCreateCarCodeOldChangeState(element.checked_AutoCreateCarCode);
      this.inputModel.checked_NeedWeight = element.checked_NeedWeight;
    }

    private currentRowChanged(element) {
      this.currentrow = element;
    }

    //获得焦点，选中文本
    private getInputFocus(event): void {
      event.currentTarget.select();
    }

    //更新设备状态数据
    public getdevicestatecallback(datas): void {
      this.deviceItems = [];
      this.deviceItems = datas;
    }

    public ClearData() {
      debugger;
      // if (
      //   this.routeNextOrgCode == "1" &&
      //   this.inputModel.checked_AutoCreateCarCode

      // )
      if (
        this.routeNextOrgCode == "1" &&
        ScanforGetOnModule.checked_AutoCreateCarCodeOld

      )
      {
        if (!this.inputModel.checked_CarCodelocked) {
          this.inputModel.input_CarLabel = "";
        }
        this.inputModel.input_NextorgSelect = "";
        this.inputModel.input_NextWebPoint = "";
      }
    }

    //更新数据列表的数据
    public datahistorycallback(data) {
      this.showList = [];
      for (let index = 0; index < data.length; index++) {
        const element = data[index];

        if (index == 0 && element.UploadStateName == "上传成功") {
          // YT2600191827105
          this.ClearData();
        }
        var str_datetime =
          element.ScanTime.getFullYear() +
          "-" +
          (element.ScanTime.getMonth() + 1 < 10 ? "0" : "") +
          (element.ScanTime.getMonth() + 1) +
          "-" +
          (element.ScanTime.getDate() < 10 ? "0" : "") +
          element.ScanTime.getDate() +
          " " +
          (element.ScanTime.getHours() < 10 ? "0" : "") +
          element.ScanTime.getHours() +
          ":" +
          (element.ScanTime.getMinutes() < 10 ? "0" : "") +
          element.ScanTime.getMinutes() +
          ":" +
          (element.ScanTime.getSeconds() < 10 ? "0" : "") +
          element.ScanTime.getSeconds();
        this.showList.push({
          index: element.index,
          code: element.code,
          CarSignNum: element.CarSignNum,
          RecvType: element.RecvType,
          NextWebPoint: element.NextWebPoint,
          Line: element.Line,
          ScanTime: str_datetime,
          UploadStateName: element.UploadStateName,
          Info: element.Info,
          state: element.UploadStateName
        });
      }
    }

    //错误消息回调显示方法
    public errormsgcallback(data) {
      this.errormessage = data;
    }

    //统计数据回显
    public statisticaldatacallback(data) {
      data.forEach(element => {
        if (element.Key == "totalScanCount") {
          this.statisticalList[0].value = element.Value;
        }
        if (element.Key == "piecesCountInCar") {
          this.statisticalList[1].value = element.Value;
        }
        if (element.Key == "totalWeight") {
          this.statisticalList[2].value = element.Value;
        }
      });
    }

    public msg = "";
    private config = config;
    private statisticalList = [];
    public currentrow = null;
    public showList = [];
    public ytoCode = "";

    //扫描区扫码
    private ytocodeget(code, e) {
      debugger;
      this.ytoCode = code;
      this.inputModel.input_ScanCode = this.ytoCode.toUpperCase();
      try {
        obj_ScanForGetOn.scanArea_Click(this.inputModel);
      } catch (error) {
      }
      var el = document.getElementById("input_scancode_id");
      this.selectElementContents(el);
    }

    public callbackmodel = {};

    //界面参数更新方法
    private scanareacallback(backdata): void {
      this.callbackmodel = backdata;
      // if (backdata.input_CarLabel.length < 20) {
      //   this.formModel2.checked_AutoCreateCarCode = false;
      // }
    }

    public deletedatahistory() {
      if (this.currentrow === null) {
        this.$message.warning("请先选择要删除的行");
        return;
      }
      this.$confirm("是否确定要删除此数据？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          try {
            obj_ScanForGetOn.deleteDataHistory(this.currentrow);
          } catch (error) {
            console.log("删除失败：" + error.message);
          }
        })
        .catch(() => {
          console.log("取消删除");
        });
    }

    public deletedatahistorycallback() {
      this.currentrow = null;
    }

    public selectElementContents(el) {
      el.blur();
      el.focus();
    }

    private deviceItems: deviceItem[] = [];
    private errormessage = "";
    private currentRow = null;
    private tableshow = true;
  }
